import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Lock } from 'lucide-react';
import { toast } from 'sonner';
import { AuthContext } from '../App';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export default function AdminLogin() {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/api/auth/login`, { email, password });
      login(res.data.token);
      toast.success('Welcome back!');
      navigate('/admin/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--surface-2)' }}>
      <Card className="w-full max-w-md" style={{ background: 'var(--surface-1)' }}>
        <CardContent className="p-8">
          <div className="text-center mb-6">
            <div className="w-12 h-12 rounded-lg mx-auto mb-4 flex items-center justify-center" style={{ background: 'rgba(14,138,138,0.1)' }}>
              <Lock className="w-6 h-6" style={{ color: 'var(--brand-teal)' }} />
            </div>
            <h1 className="text-2xl font-semibold tracking-tight" style={{ fontFamily: 'Space Grotesk', color: 'var(--brand-navy)' }}>Admin Login</h1>
            <p className="text-sm text-muted-foreground mt-1">Laminate Chillers CMS</p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" data-testid="admin-login-username-input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@laminatechillers.com" required />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" data-testid="admin-login-password-input" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022" required />
            </div>
            <Button type="submit" data-testid="admin-login-submit-button" disabled={loading} className="w-full text-white" style={{ background: 'var(--brand-teal)' }}>
              {loading ? 'Signing in...' : 'Sign In'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
